var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.63,68,110.44,191.67l256-63.64L223.85,63.43A15.09,15.09,0,0,0,205.63,68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09,192.55,205.21,67.69A15.55,15.55,0,0,1,224.07,63l144,65.23Zm108.5-130a14.49,14.49,0,0,0-11.54,5.74h0L111.78,190.8l253.06-62.91-141.2-64A14.6,14.6,0,0,0,217.59,62.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.12,157.47H389.84a0,0,0,0,1,0,0V300.94a10.71,10.71,0,0,1-10.71,10.71H135.83a10.71,10.71,0,0,1-10.71-10.71V157.47a0,0,0,0,1,0,0Z",
    transform: "translate(-48.98 69.04) rotate(-13.96)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.52,135.44l-89,90.93L128,196.09l-15.39-71.35a14.4,14.4,0,0,1,10.55-17.22l194.6-48.37a14.38,14.38,0,0,1,17.44,10.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,219.22,144.61,329.66h0a11.78,11.78,0,0,0,14.28,8.59L393.19,280a11.78,11.78,0,0,0,8.59-14.27l-.22-.88L263.36,216.1A12.36,12.36,0,0,0,250.3,219.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.21,
    y: 127.42,
    width: 78.45,
    height: 8.01,
    transform: "translate(-26.42 47.19) rotate(-13.97)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.82,
    y: 135.57,
    width: 174.06,
    height: 9.05,
    transform: "translate(-26.99 59.86) rotate(-13.97)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.16,
    y: 157.03,
    width: 174.06,
    height: 9.05,
    transform: "translate(-32.01 61.78) rotate(-13.97)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.11 164.57 317.82 169.86 176.02 206.93 157.49 202.6 156.79 200.59 325.16 158.71 325.89 161.62 323.11 164.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.84 201.52 222.96 217.4 203.43 212.94 298.9 189.19 286.84 201.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.44,223.24s-.07.11-.24.3l-.76.83-2.94,3.15-10.89,11.53c-9.22,9.71-22,23.13-36.15,37.84s-27.15,27.91-36.63,37.37c-4.74,4.73-8.6,8.55-11.28,11.16l-3.09,3-.82.77a1.49,1.49,0,0,1-.29.25,2,2,0,0,1,.25-.29l.78-.81,3-3.07L158.55,314c9.41-9.53,22.34-22.76,36.52-37.48s27-28,36.25-37.73l11-11.41,3-3.08.8-.79C246.34,223.32,246.44,223.24,246.44,223.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.56,264.83c-.05.14-29.52-10.09-65.82-22.85s-65.69-23.22-65.64-23.36,29.52,10.08,65.82,22.84S401.61,264.68,401.56,264.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.75,131.06a1.67,1.67,0,0,1-.19.25L355,132l-2.37,2.63-8.83,9.59c-7.48,8.07-17.9,19.13-29.58,31.2S291.76,198.26,283.94,206l-9.31,9.12-2.56,2.45-.67.63c-.16.14-.24.21-.25.2a2,2,0,0,1,.21-.24l.63-.67,2.49-2.52,9.18-9.24c7.76-7.81,18.43-18.63,30.11-30.69S335.91,152,343.47,144l8.95-9.47,2.45-2.56.65-.66A1.38,1.38,0,0,1,355.75,131.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.44,223.24a1.56,1.56,0,0,1-.35-.06l-1-.24-4-1c-3.42-.86-8.39-2.07-14.54-3.51-12.29-2.91-29.34-6.66-48.18-10.74s-35.88-7.89-48.15-10.9c-6.14-1.5-11.1-2.76-14.51-3.68l-3.93-1.07-1-.29a1.38,1.38,0,0,1-.34-.12l.35.07,1,.23,4,1c3.43.86,8.4,2.06,14.55,3.51,12.29,2.91,29.33,6.66,48.18,10.74s35.88,7.89,48.15,10.9c6.14,1.5,11.1,2.75,14.51,3.68l3.92,1.07,1,.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.52,135.44s-.1-.33-.27-1l-.73-2.83c-.64-2.51-1.57-6.18-2.77-10.91L337.68,80.58q-.8-3.18-1.63-6.51c-.27-1.1-.55-2.23-.84-3.36-.14-.57-.28-1.14-.46-1.69a11.14,11.14,0,0,0-.6-1.64,14.11,14.11,0,0,0-11.25-8.31,13.9,13.9,0,0,0-3.81,0c-1.26.22-2.54.57-3.83.88l-7.85,2L291,66,218.09,84.2l-73,18.12-16.39,4.06-4,1a22.33,22.33,0,0,0-3.8,1.15,14.21,14.21,0,0,0-5.92,4.79,14.62,14.62,0,0,0-1.76,3.31,15.42,15.42,0,0,0-.81,3.59c-.29,2.45.39,4.81.87,7.14q1.5,7,2.87,13.41c3.65,17.09,6.6,30.91,8.64,40.48,1,4.78,1.79,8.48,2.33,11,.25,1.25.45,2.21.59,2.87s.18,1,.18,1-.09-.33-.24-1-.36-1.61-.64-2.85c-.56-2.53-1.37-6.23-2.42-11-2.09-9.56-5.1-23.38-8.82-40.44-.92-4.27-1.9-8.74-2.91-13.41-.48-2.3-1.18-4.74-.88-7.27a15,15,0,0,1,.82-3.71,15.37,15.37,0,0,1,1.81-3.42,14.05,14.05,0,0,1,2.69-2.87,13.61,13.61,0,0,1,3.41-2.08,22.13,22.13,0,0,1,3.87-1.18l4-1L145,101.83l73-18.16,73-18.12,16.39-4.06,7.85-1.94c1.29-.32,2.55-.66,3.87-.89a14.66,14.66,0,0,1,11,2.8,14.55,14.55,0,0,1,4.54,5.75,11.41,11.41,0,0,1,.62,1.69c.18.57.32,1.14.46,1.71.28,1.13.55,2.26.83,3.37.55,2.22,1.08,4.39,1.61,6.51l9.9,40.19c1.15,4.74,2.05,8.42,2.66,10.93.3,1.25.53,2.2.68,2.85S351.52,135.44,351.52,135.44Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452,449c0,.15-90.44.27-202,.27S48,449.16,48,449s90.43-.28,202-.28S452,448.86,452,449Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mail-sent--inject-96"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "239.71 82.66 229.82 90.19 230.3 104.57 221.25 97.38 216.25 101.66 197.25 78.2 239.71 82.66",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1,93.25c0,.44,4.2,11.32,4.2,11.32l-9.05-7.19Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.1,93.25c0,.44,4.2,11.32,4.2,11.32l-9.05-7.19Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "197.25 78.2 226.1 93.25 230.3 104.57 229.82 90.19 197.25 78.2",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.25 78.2 226.1 93.25 230.3 104.57 229.82 90.19 197.25 78.2",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,272.22a12.91,12.91,0,0,1-5.13-1.25,12.91,12.91,0,0,1,5.13,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.43,274.22c0,.15-.75.1-1.59-.1s-1.5-.5-1.47-.65.75-.1,1.6.11S285.47,274.07,285.43,274.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,102.69a7.79,7.79,0,0,1-2.61-.41,7.31,7.31,0,0,1-2.52-.79,5.88,5.88,0,0,1,2.65.26A5.57,5.57,0,0,1,251.67,102.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35,106.84a17.93,17.93,0,0,1-4.71-2.36,5.69,5.69,0,0,1,2.51.86C260.46,106,261.43,106.71,261.35,106.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,113.2c-.11.11-1-.64-2.12-1.58s-2-1.74-1.87-1.87A5.8,5.8,0,0,1,268,111.2C269.09,112.16,269.85,113.1,269.74,113.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.14,121.55c-.14.07-.8-.9-1.6-2.1a7.85,7.85,0,0,1-1.3-2.3c.11-.09.95.77,1.76,2A5.68,5.68,0,0,1,276.14,121.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.77,131.42a8,8,0,0,1-.88-2.49,7.56,7.56,0,0,1-.55-2.59,5.83,5.83,0,0,1,1.07,2.44A5.46,5.46,0,0,1,279.77,131.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.31,141.92a8.24,8.24,0,0,1-.11-2.64,7.54,7.54,0,0,1,.24-2.63,5.83,5.83,0,0,1,.31,2.64A5.71,5.71,0,0,1,280.31,141.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.58,152.06a8.14,8.14,0,0,1,.74-2.53,8.4,8.4,0,0,1,1-2.43,5.29,5.29,0,0,1-.53,2.61A5.43,5.43,0,0,1,277.58,152.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.47,160.6c-.1-.12.68-1,1.63-2.08s1.71-2,1.84-1.89a5.47,5.47,0,0,1-1.43,2.25C272.54,160,271.57,160.71,271.47,160.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.65,166.28a8.26,8.26,0,0,1,2.26-1.36,8.08,8.08,0,0,1,2.41-1.08,5.53,5.53,0,0,1-2.16,1.57A5.45,5.45,0,0,1,262.65,166.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.39,168.49A8,8,0,0,1,255,168a8.23,8.23,0,0,1,2.64-.17,5.47,5.47,0,0,1-2.57.71A5.34,5.34,0,0,1,252.39,168.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.09,166.54a28.56,28.56,0,0,1,5,1.53,5.19,5.19,0,0,1-2.64-.36A5.09,5.09,0,0,1,242.09,166.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79,159.3c.15-.05.61,1,1.43,2.18s1.61,2,1.5,2.15-1.09-.6-1.95-1.83A4,4,0,0,1,234.79,159.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.23,151.11c0,.16-1.09.51-2.23,1.32s-1.75,1.82-1.89,1.74.3-1.28,1.57-2.18A3.66,3.66,0,0,1,239.23,151.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.27,154.86c-.14.08-.78-.9-1.82-1.86s-2.1-1.44-2-1.59a3.65,3.65,0,0,1,2.42,1.19A3.88,3.88,0,0,1,248.27,154.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.61,165.07a12.67,12.67,0,0,1,.49-2.57,12.85,12.85,0,0,1,.49-2.58,4.56,4.56,0,0,1,0,2.68A4.47,4.47,0,0,1,248.61,165.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.76,172.92c-.09-.13.82-.88,1.91-1.81s2-1.73,2.07-1.63-.58,1.08-1.71,2S241.84,173.05,241.76,172.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.41,177.78a6.64,6.64,0,0,1,2.28-1.35,6.47,6.47,0,0,1,2.51-.85,12.76,12.76,0,0,1-4.79,2.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,182.56c-.08-.13.87-.84,2.13-1.6a6,6,0,0,1,2.46-1c.08.15-.94.76-2.19,1.48A6.46,6.46,0,0,1,223,182.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,189.44c-.11-.1.58-1.08,1.63-2.11a5.87,5.87,0,0,1,2.13-1.59c.1.12-.71,1-1.74,2S215.16,189.54,215,189.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,198.06a5.82,5.82,0,0,1,1.08-2.43c.77-1.25,1.56-2.15,1.68-2.06a7.42,7.42,0,0,1-1.21,2.35C209.79,197.15,209.14,198.13,209,198.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,207.86a5.61,5.61,0,0,1,.48-2.61,5.69,5.69,0,0,1,1.15-2.4,17.8,17.8,0,0,1-1.63,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.78,218.3a9.8,9.8,0,0,1,.36-5.26,7.69,7.69,0,0,1,0,2.64A7.57,7.57,0,0,1,203.78,218.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,228.73a6.43,6.43,0,0,1-.83-2.52,5.38,5.38,0,0,1-.22-2.65,8.33,8.33,0,0,1,.76,2.54A6.46,6.46,0,0,1,205.16,228.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23,238.43c-.13.08-.84-.88-1.49-2.2a5.58,5.58,0,0,1-.85-2.52,7.62,7.62,0,0,1,1.34,2.28A7.54,7.54,0,0,1,209.23,238.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.55,246.86c-.1.1-1-.66-2-1.78a5.92,5.92,0,0,1-1.44-2.24c.13-.1.92.78,1.86,1.88S215.66,246.75,215.55,246.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.67,253.56a5.72,5.72,0,0,1-2.34-1.27c-1.18-.86-2-1.72-1.92-1.84a7.66,7.66,0,0,1,2.25,1.4C222.82,252.7,223.75,253.43,223.67,253.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.17,258.1a5.59,5.59,0,0,1-2.58-.65,5.45,5.45,0,0,1-2.31-1.32,8,8,0,0,1,2.51.81A8.36,8.36,0,0,1,233.17,258.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,259.45c0,.14-.09.26-.14.25s-.07-.14,0-.29.09-.26.14-.25S238.49,259.3,238.46,259.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.45,
    y: 231.3,
    width: 11.51,
    height: 7.16,
    transform: "translate(84.5 -58.24) rotate(18.18)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 218.45,
    y: 231.3,
    width: 11.51,
    height: 7.16,
    transform: "translate(84.5 -58.24) rotate(18.18)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230.79,233.28a45.37,45.37,0,0,1-6.34,2.6l-.19.07-.12-.16-.19-.24a44.91,44.91,0,0,1-4.09-5.87,47.07,47.07,0,0,1,4.53,5.54l.18.24-.31-.09A42.57,42.57,0,0,1,230.79,233.28Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.79,233.28a45.37,45.37,0,0,1-6.34,2.6l-.19.07-.12-.16-.19-.24a44.91,44.91,0,0,1-4.09-5.87,47.07,47.07,0,0,1,4.53,5.54l.18.24-.31-.09A42.57,42.57,0,0,1,230.79,233.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M223,233.85a8.22,8.22,0,0,1-2.57,1.57,8.79,8.79,0,0,1-2.82,1.07,8.5,8.5,0,0,1,2.58-1.57A8.87,8.87,0,0,1,223,233.85Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223,233.85a8.22,8.22,0,0,1-2.57,1.57,8.79,8.79,0,0,1-2.82,1.07,8.5,8.5,0,0,1,2.58-1.57A8.87,8.87,0,0,1,223,233.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M228.75,240.14a8.24,8.24,0,0,1-1.4-2.53c-.66-1.49-1.1-2.77-.9-2.75a8.36,8.36,0,0,1,1.41,2.53A7.78,7.78,0,0,1,228.75,240.14Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.75,240.14a8.24,8.24,0,0,1-1.4-2.53c-.66-1.49-1.1-2.77-.9-2.75a8.36,8.36,0,0,1,1.41,2.53A7.78,7.78,0,0,1,228.75,240.14Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 243.64,
    y: 254.85,
    width: 29.6,
    height: 18.42,
    transform: "translate(95.32 -67.47) rotate(18.18)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.38,259.93a7.18,7.18,0,0,1-1.26.57l-3.5,1.37c-3,1.13-7.09,2.67-11.7,4.36l-.19.07-.12-.16-.47-.62c-3.06-4-5.82-7.73-7.79-10.42L248,251.91a8,8,0,0,1-.79-1.22,7.9,7.9,0,0,1,1,1.09l2.45,3.09c2.05,2.62,4.85,6.27,7.92,10.32l.47.61-.31-.09c4.6-1.68,8.75-3.16,11.75-4.2l3.56-1.21A7.38,7.38,0,0,1,275.38,259.93Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275.38,259.93a7.18,7.18,0,0,1-1.26.57l-3.5,1.37c-3,1.13-7.09,2.67-11.7,4.36l-.19.07-.12-.16-.47-.62c-3.06-4-5.82-7.73-7.79-10.42L248,251.91a8,8,0,0,1-.79-1.22,7.9,7.9,0,0,1,1,1.09l2.45,3.09c2.05,2.62,4.85,6.27,7.92,10.32l.47.61-.31-.09c4.6-1.68,8.75-3.16,11.75-4.2l3.56-1.21A7.38,7.38,0,0,1,275.38,259.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M255.38,261.42a55.72,55.72,0,0,1-6.82,3.63,56.22,56.22,0,0,1-7.05,3.14,52.78,52.78,0,0,1,6.81-3.64A52.67,52.67,0,0,1,255.38,261.42Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.38,261.42a55.72,55.72,0,0,1-6.82,3.63,56.22,56.22,0,0,1-7.05,3.14,52.78,52.78,0,0,1,6.81-3.64A52.67,52.67,0,0,1,255.38,261.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M270.14,277.59a51,51,0,0,1-3.21-6.68,50.44,50.44,0,0,1-2.7-6.91,50.76,50.76,0,0,1,3.21,6.69A50.06,50.06,0,0,1,270.14,277.59Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.14,277.59a51,51,0,0,1-3.21-6.68,50.44,50.44,0,0,1-2.7-6.91,50.76,50.76,0,0,1,3.21,6.69A50.06,50.06,0,0,1,270.14,277.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M248.8,255a4.39,4.39,0,1,1,.94-6.14A4.39,4.39,0,0,1,248.8,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,250.65a20.07,20.07,0,0,1-2.95,1.82l-.7.39-.13.07-.07-.12a14.19,14.19,0,0,1-1.2-2.37,13.19,13.19,0,0,1,1.45,2.23l-.19-.06.7-.4A19.86,19.86,0,0,1,249,250.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.69,
    y: 233.68,
    width: 15.51,
    height: 9.65,
    transform: "translate(86.84 -65.62) rotate(18.18)",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 240.69,
    y: 233.68,
    width: 15.51,
    height: 9.65,
    transform: "translate(86.84 -65.62) rotate(18.18)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M257.31,236.34a3.34,3.34,0,0,1-.65.3l-1.84.72c-1.55.59-3.71,1.4-6.13,2.28l-.1,0-.06-.09-.24-.32c-1.61-2.12-3-4.05-4.09-5.46L243,232.14a4.4,4.4,0,0,1-.41-.64,3.78,3.78,0,0,1,.5.57l1.29,1.62c1.07,1.37,2.54,3.28,4.14,5.4l.25.33-.16,0c2.41-.88,4.58-1.66,6.16-2.2l1.86-.63A3.22,3.22,0,0,1,257.31,236.34Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.31,236.34a3.34,3.34,0,0,1-.65.3l-1.84.72c-1.55.59-3.71,1.4-6.13,2.28l-.1,0-.06-.09-.24-.32c-1.61-2.12-3-4.05-4.09-5.46L243,232.14a4.4,4.4,0,0,1-.41-.64,3.78,3.78,0,0,1,.5.57l1.29,1.62c1.07,1.37,2.54,3.28,4.14,5.4l.25.33-.16,0c2.41-.88,4.58-1.66,6.16-2.2l1.86-.63A3.22,3.22,0,0,1,257.31,236.34Z",
    style: {
      fill: "#2F55D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,237.12a30.14,30.14,0,0,1-3.57,1.9,29.76,29.76,0,0,1-3.7,1.65,27.53,27.53,0,0,1,3.57-1.91A28.07,28.07,0,0,1,246.84,237.12Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.84,237.12a30.14,30.14,0,0,1-3.57,1.9,29.76,29.76,0,0,1-3.7,1.65,27.53,27.53,0,0,1,3.57-1.91A28.07,28.07,0,0,1,246.84,237.12Z",
    style: {
      fill: "#2F55D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.57,245.59a26.4,26.4,0,0,1-1.68-3.5,28.28,28.28,0,0,1-1.42-3.62,50.9,50.9,0,0,1,3.1,7.12Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.57,245.59a26.4,26.4,0,0,1-1.68-3.5,28.28,28.28,0,0,1-1.42-3.62,50.9,50.9,0,0,1,3.1,7.12Z",
    style: {
      fill: "#2F55D4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139,121.57a20.88,20.88,0,1,1-15.1-25.38A20.89,20.89,0,0,1,139,121.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.47,105.11c.37.15-2,7.14-5.3,15.62-.49,1.23-1,2.41-1.41,3.57l-.25.63-.63-.24c-6.77-2.61-11.72-4.76-11.6-5.07s5.26,1.31,12.08,3.78l-.88.4c.44-1.16.9-2.35,1.37-3.58C123.14,111.73,126.11,105,126.47,105.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.65,417.09a19.33,19.33,0,0,1,12-1.46c2.18.36,4.45,1,5.94,2.64s1.76,4.52.06,5.93a5.77,5.77,0,0,1-3.74.95c-3.18,0-6.7-.6-9.24,1.31-1.45,1.09-2.41,2.9-4.14,3.44a4.11,4.11,0,0,1-4.5-2,7,7,0,0,1-.51-5.16A7.86,7.86,0,0,1,395.65,417.09Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.65,417.09a19.33,19.33,0,0,1,12-1.46c2.18.36,4.45,1,5.94,2.64s1.76,4.52.06,5.93a5.77,5.77,0,0,1-3.74.95c-3.18,0-6.7-.6-9.24,1.31-1.45,1.09-2.41,2.9-4.14,3.44a4.11,4.11,0,0,1-4.5-2,7,7,0,0,1-.51-5.16A7.86,7.86,0,0,1,395.65,417.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.28,400.93c2.24,3.19,6.58,2.13,8.59.18s2.87-4.77,3.64-7.46c1.77-6.15,3.55-12.6,2.24-18.86a10.61,10.61,0,0,0-2.41-5.13,5.48,5.48,0,0,0-5.19-1.73c-2.19.58-3.55,2.73-4.53,4.77A45.06,45.06,0,0,0,385.17,392c0,3.11.36,6.37,2.11,8.94",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.15,405.51c2.42-2.88,2.88-7.08,1.8-10.69a20.65,20.65,0,0,0-6.32-9.18A34.18,34.18,0,0,0,365.3,379a12.12,12.12,0,0,0-5.1-.87,5.37,5.37,0,0,0-4.28,2.59c-1.19,2.27-.05,5,1.19,7.28a86.83,86.83,0,0,0,7.44,11.34c2.23,2.87,4.79,5.71,8.19,7s6.93,1.15,8.73-1.21",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M381.15,405.51c2.42-2.88,2.88-7.08,1.8-10.69a20.65,20.65,0,0,0-6.32-9.18A34.18,34.18,0,0,0,365.3,379a12.12,12.12,0,0,0-5.1-.87,5.37,5.37,0,0,0-4.28,2.59c-1.19,2.27-.05,5,1.19,7.28a86.83,86.83,0,0,0,7.44,11.34c2.23,2.87,4.79,5.71,8.19,7s6.93,1.15,8.73-1.21"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M387.13,449.06a7.15,7.15,0,0,0,.2-1.45c.11-1.06.23-2.38.39-4a56.48,56.48,0,0,1,.89-5.8,44.23,44.23,0,0,1,2.11-6.85,25.25,25.25,0,0,1,3.5-6.2,13,13,0,0,1,4.42-3.68,12.6,12.6,0,0,1,3.72-1.16,7,7,0,0,0,1.44-.2,6,6,0,0,0-1.46,0,11.41,11.41,0,0,0-3.89,1,13.13,13.13,0,0,0-4.66,3.71,24.78,24.78,0,0,0-3.63,6.32,42.19,42.19,0,0,0-2.09,7,48.28,48.28,0,0,0-.77,5.87c-.13,1.68-.18,3-.2,4A7.1,7.1,0,0,0,387.13,449.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4,446a2.49,2.49,0,0,0,0-.67v-1.92c0-1.67,0-4.09.08-7.07.15-6,.66-14.21,1.66-23.26s2.32-17.2,3.53-23c.28-1.46.57-2.78.84-3.93s.48-2.16.69-3,.33-1.38.45-1.87a2.71,2.71,0,0,0,.12-.67,2.83,2.83,0,0,0-.23.63l-.56,1.85c-.25.8-.5,1.79-.79,2.94s-.62,2.46-.94,3.93A219.26,219.26,0,0,0,388.58,413c-1,9.07-1.44,17.33-1.48,23.31,0,3,0,5.41.1,7.08q.07,1.17.12,1.92A3.59,3.59,0,0,0,387.4,446Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.44,430.08a12.35,12.35,0,0,0,0-2,52.73,52.73,0,0,0-.62-5.44,75.45,75.45,0,0,0-5.08-17.32A49.92,49.92,0,0,0,372,390.14a23.94,23.94,0,0,0-2.29-2.13c-.35-.3-.66-.59-1-.83l-.88-.61a13.4,13.4,0,0,0-1.7-1.09,60.92,60.92,0,0,1,5.55,4.95,52.73,52.73,0,0,1,9.5,15.12,75.14,75.14,0,0,1,3.33,9.3c.87,2.91,1.45,5.59,1.89,7.85s.65,4.11.8,5.39A14,14,0,0,0,387.44,430.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-96"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "235.35 298.25 277.22 298.25 293.8 251.93 291.48 251.93 275.04 295.99 235.35 296.22 235.35 298.25",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-96"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.85 304.1 218.4 449.19 222.66 449.19 220.93 303.03 216.85 304.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.47,302.69c-.57,2.77,3.84,146.83,3.84,146.83h4l-3.25-146.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.42 298.25 177.39 298.25 177.39 305.59 192.08 305.59 182.52 448.72 186.7 448.95 196.27 305.59 340.44 305.59 347.43 449.01 351.62 449.01 344.63 305.59 355.42 305.59 355.42 298.25",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255,443.73l0-11-20.61-.21-.23,16.1,1.28.09c5.68.38,28.92,1.5,32.73.39C272.41,447.86,255,443.73,255,443.73Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.62,448.53a7.13,7.13,0,0,0-2.58-4.42,7,7,0,0,0-4.8-1.55l-.06,5.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.48,446.05s6.12,1.84,5.34,2.84-24.3.75-34.67-.27l0-.46,27.44.53S262.28,446.09,263.48,446.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.87,448.14l.35,0,1,.08,3.74.2c3.16.15,7.53.29,12.36.35s9.21,0,12.37-.07l3.75-.11,1-.05.35,0a1.35,1.35,0,0,0-.35,0h-1l-3.75,0c-3.16,0-7.54,0-12.36,0s-9.2-.18-12.36-.28l-3.75-.12-1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.62,449a8.23,8.23,0,0,1,.72-1.78,8.09,8.09,0,0,1,1.29-1.42,3.32,3.32,0,0,0-2,3.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,445.86c.06,0,.36-.32.66-.79s.51-.88.45-.92-.35.32-.66.79A2.38,2.38,0,0,0,255.57,445.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.91,445c.05.05.38-.16.74-.48s.61-.61.56-.66-.37.16-.73.47S253.87,444.91,253.91,445Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.88,443a2.35,2.35,0,0,0,1.07.15,2.46,2.46,0,0,0,1.08-.1,2.35,2.35,0,0,0-1.07-.15A2.49,2.49,0,0,0,252.88,443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.53,441.63a3.06,3.06,0,0,0,2.44.21,150.5,150.5,0,0,1-2.44-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,444.07a3.9,3.9,0,0,0,1.33,0,7.38,7.38,0,0,0,1.41-.29,3.84,3.84,0,0,0,.81-.33.67.67,0,0,0,.33-.4.54.54,0,0,0-.19-.54,2.44,2.44,0,0,0-3,.68,2.35,2.35,0,0,0-.45.88c0,.23,0,.36,0,.36a3.47,3.47,0,0,1,.61-1.12,2.35,2.35,0,0,1,1.14-.73,2.07,2.07,0,0,1,1.58.13c.21.16.12.4-.11.54a4.09,4.09,0,0,1-.75.31,9.08,9.08,0,0,1-1.37.34C256.8,444,256.29,444,256.29,444.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.63,444.14a1.32,1.32,0,0,0,.17-.92,2.29,2.29,0,0,0-.35-1,1.34,1.34,0,0,0-1.1-.69.52.52,0,0,0-.41.61,1.48,1.48,0,0,0,.21.59,4.75,4.75,0,0,0,.62.81,1.83,1.83,0,0,0,.75.54s-.26-.24-.62-.66a4.44,4.44,0,0,1-.54-.8c-.18-.28-.3-.79,0-.84s.67.3.87.57a2.3,2.3,0,0,1,.36.86A4,4,0,0,1,256.63,444.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.35,442.51s.59-.05,1.52.07a6.65,6.65,0,0,1,3.31,1.4,6.71,6.71,0,0,1,2,3c.3.88.33,1.48.37,1.47s0-.15,0-.41a6,6,0,0,0-.21-1.12,6.29,6.29,0,0,0-5.5-4.48,5.1,5.1,0,0,0-1.14,0A.94.94,0,0,0,234.35,442.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.58,434a68.94,68.94,0,0,0-.2,8.46,35.07,35.07,0,0,0,.22-4.23A37.71,37.71,0,0,0,236.58,434Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.24,446.55a11.32,11.32,0,0,0,3,.33,11.19,11.19,0,0,0,3-.21c0-.07-1.35,0-3,0S244.25,446.48,244.24,446.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2,446.5c0,.05.11.29.24.6s.21.58.28.58.11-.33-.05-.68S240.25,446.45,240.2,446.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,444.59c0,.05.08.26.29.48s.42.36.47.31-.08-.26-.29-.48S238.75,444.54,238.7,444.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.53,443.7c0,.07.29.07.59.18s.52.28.57.23-.11-.33-.49-.46S236.51,443.64,236.53,443.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,443.28c0,.06.09.17.26.24s.33.07.35,0-.09-.17-.26-.24S235,443.21,235,443.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.52,432.63,291,422.58l-18.87,8.29,6.41,14.76,1.2-.44c5.34-2,27-10.53,30-13.11C313.13,429.2,295.52,432.63,295.52,432.63Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,442.48a7.15,7.15,0,0,0-4.18-3,7,7,0,0,0-5,.57l2.31,5.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.25,431.23s6.33-.85,6,.39-21.84,10.68-31.71,14l-.15-.43,25.22-10.81S303.17,431.76,304.25,431.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.11,445.32l.34-.11,1-.35,3.5-1.36c2.94-1.17,7-2.83,11.41-4.77s8.39-3.77,11.24-5.15l3.37-1.64.91-.47a1.46,1.46,0,0,0,.31-.17l-.33.13-.93.42-3.4,1.58c-2.87,1.32-6.85,3.14-11.27,5.07s-8.46,3.63-11.38,4.84l-3.46,1.43-.94.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77,434.69a7.87,7.87,0,0,1-.08-1.92,9.15,9.15,0,0,1,.59-1.83,2.77,2.77,0,0,0-.84,1.79A2.8,2.8,0,0,0,303.77,434.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,434.3c.07,0,.19-.43.28-1s.1-1,0-1-.19.43-.28,1A2.06,2.06,0,0,0,297,434.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08,434.17c.06,0,.27-.31.47-.74s.3-.81.24-.84-.27.3-.47.74S295,434.14,295.08,434.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.33,432.81a2.58,2.58,0,0,0,1-.31c.55-.23,1-.47.94-.53s-.49.07-1,.3S293.3,432.74,293.33,432.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.45,431.7a2.13,2.13,0,0,0,1.24-.17,2.08,2.08,0,0,0,1.06-.64,6.69,6.69,0,0,0-1.15.41A6.39,6.39,0,0,0,292.45,431.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.88,432.38a4,4,0,0,0,1.21-.54,8,8,0,0,0,1.16-.85,4.08,4.08,0,0,0,.61-.63.73.73,0,0,0,.13-.51.5.5,0,0,0-.39-.4,2.44,2.44,0,0,0-2.51,2.83.88.88,0,0,0,.11.35,4,4,0,0,1,.1-1.28,2.36,2.36,0,0,1,.74-1.13,2.09,2.09,0,0,1,1.49-.53c.26.05.28.31.12.54a4.33,4.33,0,0,1-.55.59,10.4,10.4,0,0,1-1.11.87C297.32,432.14,296.86,432.34,296.88,432.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.22,432.3a1.36,1.36,0,0,0-.23-.9,2.31,2.31,0,0,0-.72-.75,1.34,1.34,0,0,0-1.28-.17.52.52,0,0,0-.13.72,1.35,1.35,0,0,0,.44.45,4.29,4.29,0,0,0,.9.49,1.88,1.88,0,0,0,.91.18s-.34-.11-.84-.35a4.25,4.25,0,0,1-.83-.5c-.28-.18-.59-.59-.31-.78a1.18,1.18,0,0,1,1,.16,2.15,2.15,0,0,1,.69.64A5.38,5.38,0,0,1,297.22,432.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.24,440s.51-.29,1.41-.56a6.46,6.46,0,0,1,6.67,1.77c.64.69.91,1.22.95,1.19a1.47,1.47,0,0,0-.17-.38,5.18,5.18,0,0,0-.65-.92,6.34,6.34,0,0,0-3.14-2,6.44,6.44,0,0,0-3.71.15,5.28,5.28,0,0,0-1,.49C276.34,439.88,276.23,440,276.24,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.75,431.27a33.54,33.54,0,0,0,1.53,4,38.4,38.4,0,0,0,1.77,3.85,35.66,35.66,0,0,0-1.54-3.95A38.43,38.43,0,0,0,274.75,431.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.91,439.6a12,12,0,0,0,2.88-.94,11.08,11.08,0,0,0,2.66-1.43c0-.06-1.23.55-2.76,1.2S286.89,439.53,286.91,439.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.21,441.21c0,.07.22.22.47.45s.43.45.49.41,0-.34-.32-.6S283.23,441.15,283.21,441.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.06,440.09c0,.07.18.21.46.32s.53.15.56.09-.18-.21-.46-.32S281.08,440,281.06,440.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.72,440.17c0,.06.29-.05.61-.07s.58,0,.61,0-.24-.26-.63-.22S278.67,440.12,278.72,440.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.13,440.42c0,.07.16.12.34.11s.33-.07.33-.14-.16-.12-.34-.11S277.13,440.35,277.13,440.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51,359.12,93.63,247.93a4.69,4.69,0,0,1,5-5.3l35.87,3a6.78,6.78,0,0,1,6.19,6.21l8.74,105.27Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.51,359.12,93.63,247.93a4.69,4.69,0,0,1,5-5.3l35.87,3a6.78,6.78,0,0,1,6.19,6.21l8.74,105.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M143.11,195.71c-.3-4.24-1.41-8.37-2-12.57s-.71-8.62.95-12.53a18.27,18.27,0,0,1,10.34-9.46,31.68,31.68,0,0,1,14.18-1.62,6.71,6.71,0,0,1,2.51.57,2.49,2.49,0,0,1,1.43,2,1.55,1.55,0,0,1-1.59,1.62,25.2,25.2,0,0,1,5.37,1.15,3.15,3.15,0,0,1,1.74,1.25,2.39,2.39,0,0,1-.24,2.36,7,7,0,0,1-1.81,1.7,1.66,1.66,0,0,1,1.95,1.31,3.16,3.16,0,0,1-.69,2.47c-.51.72-1.17,1.31-1.7,2-2.16,2.87-1.74,6.86-1.22,10.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,220.55l20.21-.36c.27-2.34.66-11.44.66-11.44s8.45-.78,9.07-9.14.36-27.66.36-27.66h0a29.13,29.13,0,0,0-29.44,1.87l-1.3.88Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,186.45a1.22,1.22,0,1,1,1.73,0A1.21,1.21,0,0,1,171,186.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.13,184.42c-.14.14-.92-.54-2.07-.62s-2,.47-2.15.31.09-.32.47-.58a2.88,2.88,0,0,1,3.37.25C173.09,184.09,173.2,184.36,173.13,184.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.79,184.61a1.22,1.22,0,1,1-1.69.29A1.21,1.21,0,0,1,159.79,184.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.55,184.67c-.14.13-.92-.55-2.07-.63s-2,.47-2.14.32.08-.33.47-.58a2.83,2.83,0,0,1,3.36.25C160.51,184.33,160.62,184.61,160.55,184.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59,194.46a5.58,5.58,0,0,1,1.88-.28c.31,0,.55-.07.58-.23a1.71,1.71,0,0,0-.16-.88c-.25-.78-.51-1.57-.77-2.4-1.05-3.41-1.77-6.22-1.59-6.27s1.16,2.67,2.22,6.08c.25.83.48,1.63.72,2.41a2,2,0,0,1,.08,1.27.79.79,0,0,1-.55.45,2.38,2.38,0,0,1-.51,0A5.65,5.65,0,0,1,164.59,194.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,195.5c-1.15-.79,3.2,2,5.55,2a3.17,3.17,0,0,1-3.83,1C160,197.45,160.76,195.5,160.76,195.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,208.63a19.45,19.45,0,0,1-10.72-3.77s2.21,6.18,10.6,5.94Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.79,181l.43,10.85s3.81-1.16,4.06-1.27-.07-13.29-.07-13.29-.53-5,2.71-6.15c3.41-1.23,4.89,1.24,9.72,2,15.93,2.69,14.84-2.2,14.84-2.2s2-2.15-2.09-4.51-14.32-3.16-19.92-1.23c-11,3.79-11.66,7.56-11.66,10.89C140.81,180.84,142.79,181,142.79,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.66,182.12c-.18-.07-6.2-.85-5.63,6.26s7.56,4.19,7.56,4S144.66,182.12,144.66,182.12Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.21,190s-.12.1-.32.21a1.25,1.25,0,0,1-.93.09,3,3,0,0,1-1.63-2.63,4.12,4.12,0,0,1,.2-1.81,1.44,1.44,0,0,1,.86-1,.64.64,0,0,1,.76.28c.11.19.07.34.11.35s.14-.14.06-.42a.77.77,0,0,0-.31-.43,1,1,0,0,0-.7-.12,1.74,1.74,0,0,0-1.21,1.2,4.18,4.18,0,0,0-.27,2c.16,1.43,1,2.71,2,2.93a1.34,1.34,0,0,0,1.12-.28C144.21,190.22,144.23,190.05,144.21,190Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,278s10-.48,12,.43c3.46,1.51,13.76,17.66,13.24,17.66-1.56,0-4.77,0-4.77,0l-16-6.07-3.77.95Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.08,324.37S297,428,297.07,427.49s-26.82,12.93-26.82,12.93l-18.14-74.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.66 441.05 298 427.22 296.77 423.43 268.21 437.28 269.66 441.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.94,402.93c-.15,0-.46-.61-.71-1.44s-.33-1.56-.18-1.6.46.6.71,1.44S266.08,402.88,265.94,402.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.79,409c-.15,0-.48-.6-.73-1.43s-.35-1.55-.21-1.6.47.6.73,1.43S267.93,408.93,267.79,409Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.72,415c-.15.05-.48-.59-.75-1.42s-.37-1.54-.23-1.59.48.59.75,1.42S269.86,415,269.72,415Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.74,421c-.15.05-.49-.58-.77-1.41s-.4-1.54-.25-1.59.49.58.77,1.41S271.88,421,271.74,421Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.84,427c-.14,0-.5-.58-.79-1.4s-.42-1.53-.27-1.58.49.57.79,1.4S274,426.92,273.84,427Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,432.91c-.15,0-.51-.57-.81-1.39s-.44-1.53-.3-1.58.51.57.81,1.39S276.17,432.86,276,432.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.43,435.4a4.72,4.72,0,0,1-.6-1.08c-.35-.72-.83-1.77-1.38-3.08-1.11-2.62-2.48-6.31-3.86-10.42s-2.54-7.87-3.36-10.59c-.38-1.28-.7-2.36-1-3.23a4.84,4.84,0,0,1-.28-1.21,6.51,6.51,0,0,1,.48,1.14c.28.75.66,1.83,1.12,3.18l3.51,10.53c1.37,4.11,2.68,7.81,3.7,10.46l1.22,3.13A5.89,5.89,0,0,1,274.43,435.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.49,317.17c.25-5.49-2.87,30.13,24.51,31.07s83.32.53,83.32.53l-6.55,90.33h32.85L268.48,343s3.5-27.84-15.55-31.39c-11.92-2.23-86.05-2.94-86.05-2.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.02 439.29 262.61 439.29 262.61 433.91 228.02 433.96 228.02 439.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.91,344a1.39,1.39,0,0,1,.35,0l1-.06,4-.18,14.85-.57,50.09-1.72h.32l0,.32c-.45,3.68-.83,7.57-1.15,11.52-.44,5.65-.86,11.16-1.27,16.48s-1,10.44-1.51,15.32c-1,9.74-1.94,18.52-2.72,25.91s-1.43,13.31-1.88,17.46c-.23,2-.41,3.64-.54,4.75q-.09.78-.15,1.23a2.78,2.78,0,0,1-.07.42,1.9,1.9,0,0,1,0-.42c0-.31.06-.72.1-1.24.1-1.12.25-2.72.44-4.76.4-4.15,1-10.12,1.71-17.48s1.62-16.17,2.6-25.93c.48-4.88,1-10,1.47-15.31s.83-10.83,1.26-16.47c.32-4,.7-7.85,1.16-11.55l.28.31-50.1,1.53-14.85.41-4,.08h-1A1.29,1.29,0,0,1,173.91,344Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,340.09c0,.15-.7.29-1.58.31s-1.58-.08-1.58-.23.7-.3,1.57-.32S177.07,339.94,177.07,340.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,339.94c0,.15-.7.29-1.58.31s-1.58-.08-1.59-.23.71-.29,1.58-.32S183.4,339.79,183.4,339.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.73,339.79c0,.16-.7.29-1.58.32s-1.58-.09-1.59-.24.71-.29,1.58-.31S189.73,339.64,189.73,339.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.06,339.64c0,.16-.7.3-1.58.32s-1.58-.09-1.59-.24.71-.29,1.58-.31S196.06,339.49,196.06,339.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.39,339.5c0,.15-.7.29-1.58.31s-1.58-.09-1.59-.24.71-.29,1.58-.31S202.39,339.34,202.39,339.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72,339.35c0,.15-.7.29-1.58.31s-1.58-.09-1.59-.24.71-.29,1.58-.31S208.71,339.2,208.72,339.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.05,339.2c0,.15-.7.29-1.58.31s-1.58-.09-1.59-.24.7-.29,1.58-.31S215,339.05,215.05,339.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.38,339.05c0,.15-.7.29-1.58.31s-1.58-.08-1.59-.24.7-.29,1.58-.31S221.37,338.9,221.38,339.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.71,338.9c0,.15-.7.29-1.58.31s-1.58-.08-1.59-.23.7-.3,1.58-.32S227.7,338.75,227.71,338.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,338.75c0,.15-.71.29-1.58.31s-1.58-.08-1.59-.23.7-.3,1.58-.32S234,338.6,234,338.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,338.6c0,.15-.71.29-1.58.31s-1.58-.08-1.59-.23.7-.29,1.58-.31S240.36,338.45,240.37,338.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7,338.45c0,.16-.71.3-1.58.32s-1.59-.09-1.59-.24.7-.29,1.58-.31S246.69,338.3,246.7,338.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.69,344.19c-.16,0-.21-.73-.12-1.6s.27-1.56.42-1.55.21.73.12,1.6S246.84,344.21,246.69,344.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.07,350.49c-.15,0-.21-.73-.12-1.6s.28-1.56.43-1.55.2.73.12,1.6S246.22,350.51,246.07,350.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,356.79c-.15,0-.21-.73-.12-1.6s.28-1.56.43-1.55.2.74.12,1.61S245.6,356.81,245.45,356.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.83,363.09c-.15,0-.2-.73-.12-1.6s.28-1.56.43-1.55.2.74.12,1.61S245,363.11,244.83,363.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.21,369.4c-.15,0-.2-.74-.12-1.61s.28-1.56.43-1.54.21.73.12,1.6S244.36,369.41,244.21,369.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.59,375.7c-.15,0-.2-.74-.11-1.61s.27-1.56.42-1.54.21.73.12,1.6S243.75,375.71,243.59,375.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,382c-.16,0-.21-.73-.12-1.6s.27-1.57.43-1.55.2.73.11,1.6S243.13,382,243,382Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.36,388.3c-.15,0-.21-.73-.12-1.6s.28-1.57.43-1.55.2.73.12,1.6S242.51,388.31,242.36,388.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.74,394.6c-.15,0-.2-.73-.12-1.6s.28-1.56.43-1.55.2.73.12,1.6S241.89,394.62,241.74,394.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.12,400.9c-.15,0-.2-.73-.12-1.6s.28-1.56.43-1.55.2.73.12,1.6S241.27,400.92,241.12,400.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5,407.2c-.15,0-.2-.73-.12-1.6s.28-1.56.43-1.55.21.73.12,1.6S240.65,407.22,240.5,407.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.89,413.5c-.16,0-.21-.73-.12-1.6s.27-1.56.42-1.55.21.74.12,1.61S240,413.52,239.89,413.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.27,419.8c-.15,0-.21-.73-.12-1.6s.27-1.56.43-1.55.2.74.11,1.61S239.42,419.82,239.27,419.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.65,426.11c-.15,0-.21-.74-.12-1.61s.28-1.56.43-1.54.2.73.12,1.6S238.8,426.12,238.65,426.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,432.41c-.15,0-.2-.73-.12-1.6s.28-1.57.43-1.55.2.73.12,1.6S238.18,432.42,238,432.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7,435.75c-.15,0-.27-.07-.26-.12s.13-.09.28-.07.27.07.27.12S237.85,435.76,237.7,435.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.8,344.56a9.2,9.2,0,0,1-2.15,2.35,9.6,9.6,0,0,1-2.53,1.94,18.61,18.61,0,0,1,4.68-4.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.07,345.78a15,15,0,0,1-3.53,1.89,14.69,14.69,0,0,1-3.76,1.38,15,15,0,0,1,3.53-1.89A14.83,14.83,0,0,1,242.07,345.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.27,274.1s-3.35-35.89-9.3-51.6l1.18-.89-1.77-6.19-22.26-2.7.34,4.83a15.87,15.87,0,0,0-7.61,7.24c-8,16.94-4,36.72-8.29,73.37,0,0-5,17.19.16,22.57l48.57-11.32L174,298.33c21.2-.4,56.06-4.3,56.06-4.3l-1-20.06s-52.09.31-53.79.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.34,215.39a16.81,16.81,0,0,1,1.61,4,7,7,0,0,1,.44,1.7,1.2,1.2,0,0,1-.28.83,1.44,1.44,0,0,1-.6.42c-.84.26-1.32.08-1.32,0s.52-.09,1.15-.39a.93.93,0,0,0,.55-.88,10.57,10.57,0,0,0-.46-1.55A17.14,17.14,0,0,1,165.34,215.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.65,242.11c0,.16-9,.28-20,.28s-20-.12-20-.28,9-.27,20-.27S170.65,242,170.65,242.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,232c0,.15-7.94.28-17.72.28s-17.72-.13-17.72-.28,7.93-.27,17.72-.27S168.56,231.85,168.56,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.64,223.11c0,.15-6.56.27-14.66.27s-14.65-.12-14.65-.27,6.56-.28,14.65-.28S165.64,223,165.64,223.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,216.83a111,111,0,0,1-11.23.28,111,111,0,0,1-11.23-.28c0-.15,5-.27,11.23-.27S165.35,216.68,165.35,216.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.06,251.84c0,.15-9.47.27-21.15.27s-21.15-.12-21.15-.27,9.47-.28,21.15-.28S172.06,251.68,172.06,251.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.78,261.61c0,.15-9.85.27-22,.27s-22-.12-22-.27,9.85-.28,22-.28S173.78,261.46,173.78,261.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.86,270.61c0,.16-10.1.28-22.55.28s-22.55-.12-22.55-.28,10.1-.27,22.55-.27S174.86,270.46,174.86,270.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,280.46c0,.15-21.3.27-47.57.27s-47.58-.12-47.58-.27,21.3-.28,47.58-.28S224.08,280.31,224.08,280.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.45,288.34c0,.16-21.46.28-47.93.28s-47.94-.12-47.94-.28,21.46-.27,47.94-.27S224.45,288.19,224.45,288.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.24,298.06c0,.16-10.25.28-22.9.28s-22.91-.12-22.91-.28,10.25-.27,22.91-.27S173.24,297.91,173.24,298.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,307.08c0,.15-11.15.28-24.9.28s-24.9-.13-24.9-.28,11.15-.27,24.9-.27S175.57,306.93,175.57,307.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.17,309.47c-.16,0-.28-17.49-.28-39.06s.12-39.06.28-39.06.27,17.49.27,39.06S133.32,309.47,133.17,309.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.18,308.51c-.15,0-.27-21.38-.27-47.75S145,213,145.18,213s.28,21.37.28,47.75S145.34,308.51,145.18,308.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.45,307.08c-.15,0-.27-20.61-.27-46s.12-46,.27-46,.28,20.61.28,46S158.61,307.08,158.45,307.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6,309.44c-.15,0-.27-16.18-.27-36.13s.12-36.14.27-36.14.28,16.18.28,36.14S169.75,309.44,169.6,309.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41,274.05a22.17,22.17,0,0,1,.11,3.52c0,2.17,0,5.16-.12,8.46s-.18,6.3-.28,8.46a24.55,24.55,0,0,1-.28,3.51,21.88,21.88,0,0,1-.11-3.51c0-2.17,0-5.16.12-8.47s.18-6.3.28-8.47A21.31,21.31,0,0,1,181.41,274.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,274.47a20.86,20.86,0,0,1,.11,3.3c0,2,0,4.83-.1,7.92s-.18,5.9-.27,7.93a18.66,18.66,0,0,1-.28,3.28,20.48,20.48,0,0,1-.11-3.28c0-2,0-4.84.11-7.94s.17-5.9.27-7.93A18.2,18.2,0,0,1,194,274.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.52,274.25a17.58,17.58,0,0,1,.12,3.19c0,2,0,4.69-.1,7.69s-.17,5.72-.27,7.68A17.1,17.1,0,0,1,206,296a19.78,19.78,0,0,1-.12-3.18c0-2,0-4.69.11-7.69s.17-5.73.26-7.69A19.57,19.57,0,0,1,206.52,274.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.09,273.9a16.32,16.32,0,0,1,.12,3.09c0,1.91,0,4.55-.1,7.46s-.16,5.55-.26,7.45a18,18,0,0,1-.26,3.09,16.74,16.74,0,0,1-.13-3.09c0-1.91,0-4.55.1-7.46s.17-5.56.26-7.46A17,17,0,0,1,219.09,273.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.91,278.57a10.39,10.39,0,0,1,4.66-5.21,27.12,27.12,0,0,1-2.37,2.57A28,28,0,0,1,170.91,278.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.78,278.81a5.49,5.49,0,0,1,2-5.45c.12.11-.72,1.13-1.26,2.63S174,278.81,173.78,278.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,293.92a85.52,85.52,0,0,1-1.14-9.59,86.34,86.34,0,0,1-.6-9.65,81.41,81.41,0,0,1,1.15,9.6A84.55,84.55,0,0,1,225,293.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.63,278.46c0,.07-.28.27-.32.77a1,1,0,0,0,.25.73.75.75,0,0,0,.84.11.78.78,0,0,0,.5-.69,1,1,0,0,0-.37-.68c-.39-.31-.76-.21-.78-.29s.37-.36,1,0a1.26,1.26,0,0,1,.66,1,1.24,1.24,0,0,1-.78,1.22,1.26,1.26,0,0,1-1.44-.26,1.28,1.28,0,0,1-.25-1.15C225.12,278.49,225.64,278.39,225.63,278.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.21,274h.25l.73.06c.65.07,1.61.13,2.87.17,2.52.1,6.22.15,10.93.11,9.41-.06,22.86-.41,39-1h.23v.23c.32,6.23.66,13,1,20.18v.23l-.21,0c-2.56.48-5.15.68-7.8.95l-8.08.7c-5.49.45-11.14.87-16.89,1.28l-21.14,1.42h0c-6.13-.39-12.08-2.59-16.24-6.63a19.86,19.86,0,0,1-4.71-6.93,49.4,49.4,0,0,1-2.37-7.62c-2.47-10-4-19.11-5.25-26.67-.6-3.78-1.11-7.19-1.54-10.17a62.06,62.06,0,0,1-.89-7.67,9.43,9.43,0,0,1,1-4.72,4.76,4.76,0,0,1,1-1.33,9.36,9.36,0,0,0-.93,1.38,9.55,9.55,0,0,0-.88,4.67,64.3,64.3,0,0,0,1,7.63c.47,3,1,6.38,1.62,10.16,1.26,7.54,2.86,16.59,5.35,26.6a50.22,50.22,0,0,0,2.37,7.55,19.34,19.34,0,0,0,4.62,6.75c4,3.93,9.89,6.08,15.91,6.47h0l21.13-1.44,16.88-1.27,8.08-.69c2.63-.27,5.27-.47,7.72-.93l-.2.27c-.34-7.15-.66-13.95-1-20.19l.25.23c-16.13.59-29.58.87-39,.85-4.71,0-8.41-.09-10.93-.24-1.26-.07-2.23-.15-2.88-.25l-.73-.09A1,1,0,0,1,175.21,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.21,274a9.13,9.13,0,0,1-.52-1.57c-.29-1-.69-2.5-1.17-4.34-1-3.67-2.15-8.78-3.43-14.42s-2.45-10.75-3.33-14.44l-1-4.37a8.41,8.41,0,0,1-.31-1.62,10.39,10.39,0,0,1,.52,1.57c.31,1,.71,2.49,1.2,4.33,1,3.66,2.22,8.76,3.5,14.41S173,264.21,173.9,268c.4,1.78.74,3.25,1,4.38A11,11,0,0,1,175.21,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.41,215.81a4.48,4.48,0,0,1-.11,1.1c-.1.71-.26,1.72-.48,3a16.53,16.53,0,0,1-.42,2.07,1.49,1.49,0,0,1-.9,1,2.63,2.63,0,0,1-1.34,0c-1.65-.34-3.45-.78-5.33-1.29-3.75-1-7.09-2.11-9.52-2.86l-2.87-.9a4.32,4.32,0,0,1-1-.39,4.12,4.12,0,0,1,1.09.18c.7.16,1.7.4,2.93.74,2.46.65,5.82,1.67,9.56,2.7,1.87.51,3.65,1,5.29,1.33a2.2,2.2,0,0,0,1.09.07,1,1,0,0,0,.62-.67c.22-.64.31-1.38.46-2,.26-1.24.49-2.24.65-2.94A4.07,4.07,0,0,1,165.41,215.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.91 354.25 154.9 449.12 157.82 448.44 156.73 356.25 147.91 354.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.29 357.55 97.06 449.01 100.9 449.01 131.29 357.55 118.29 357.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.44 357.55 203.4 449.01 206.5 449.01 183.49 357.55 174.44 357.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.32 363.69 113.42 406.1 113.42 408.42 180.13 363.69 178.32 363.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.25 363.69 193.57 411.01 193.57 407.39 125.31 361.62 123.25 363.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,359.12l83.62-1.51a5.35,5.35,0,0,0,5.21-6h0a5.33,5.33,0,0,0-5.39-4.72l-84.81,1.36Z",
    style: {
      fill: "#2F55D4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.59,359.12l83.62-1.51a5.35,5.35,0,0,0,5.21-6h0a5.33,5.33,0,0,0-5.39-4.72l-84.81,1.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100.07,294.48l8.44,64.64,65.93-1.57-.17-39.26a11,11,0,0,0-12-11.12L112,311.71l-6.62-68.51-6.68-.57a4.7,4.7,0,0,0-5,5.32Z",
    style: {
      fill: "#2F55D4"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a8ec43cbae12dc4bdd0ffaf0b29b7a23.svg";
export { ForwardRef as ReactComponent };